const isLocal = window.location.hostname === 'localhost';

const config = {
  API_BASE_URL: isLocal ? 'https://slateblue-mallard-430836.hostingersite.com' : 'https://slateblue-mallard-430836.hostingersite.com',
};

export default config;

